module.exports = __webpack_public_path__ + "img/error.6d730ed2.png";